import { useDispatch, useSelector } from "react-redux";
import InsufficientPermission from "../../custom/InSufficientPermission"
import Pagination from '@mui/material/Pagination'
import NoDataImg from '../../../assets/img/no-data.gif'
import { v4 as uuidv4 } from 'uuid'
import NavBar from "../../structure/NavBar"
import { Box, Switch } from "@mui/material"
import { NavBarTop } from "../../structure/NavBarTop"
import { Button, Dropdown, Form, InputGroup, Modal, Badge } from "react-bootstrap"
import AddIcon from '@mui/icons-material/Add'
import { useCallback, useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import Utils from "../../constants/Utils";
import { AddViewerSubscription } from "./AddViewerSubscription";
import { updateTopHeader, updateLoading } from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const ViewerSubscriptionList = () => {
    const { formatDate } = Utils();
    const [callAPi, setCallAPi] = useState('')
    const dispatch = useDispatch();
    const LOADING_ENABLE = useSelector((state) => state?.loading);
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    });
    const [sort_type, setSortType] = useState('createdAt');
    const [sort_order, setSortOrder] = useState(false);
    const [datalist, setDatalist] = useState([]);
    const [page, setPage] = useState(1);
    const userData = useSelector((state) => state?.userData);
    const [searchText, setSearchText] = useState('');
    const userPermisiions = useSelector(state => state?.permission)
    
    // Modal states
    const [showNetworkProviderModal, setShowNetworkProviderModal] = useState(false);
    const [showCountryModal, setShowCountryModal] = useState(false);
    const [selectedNetworkProviders, setSelectedNetworkProviders] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    
    // Add/Edit Viewer Subscription Modal states
    const [showAddViewerSubscription, setShowAddViewerSubscription] = useState(false);
    const [viewerSubscriptionFormData, setViewerSubscriptionFormData] = useState({
        id: '',
        name: '',
        amount: 0,
        duration: 0,
        category: 'DAILY',
        benefit: '',
        selectedCountries: [],
        selectedNetworkProviders: [],
        networkProviders: []
    });
    
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;

    // Permission checking - using a generic module ID for now
    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '39') { // You may need to update this module ID
                return element
            }
        })?.permissions
        if (currentModulePermission) {
            viewPermission = currentModulePermission.find((element) => {
                if (element.name === 'VIEW') {
                    return element
                }
            }).isEnable
            editPermission = currentModulePermission.find((element) => {
                if (element.name === 'EDIT') {
                    return element
                }
            }).isEnable
            deletePermissionVal = currentModulePermission.find((element) => {
                if (element.name === 'DELETE') {
                    return element
                }
            }).isEnable
            activePermission = currentModulePermission.find((element) => {
                if (element.name === 'ACTIVE') {
                    return element
                }
            }).isEnable
        }
    }

    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }

    const handleStatusChange = async (event, id) => {
        // Implement status change logic if needed
        // Similar to other components in the project
    };

    const handleFilterClick = useCallback(() => {
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [searchText, startDate, endDate, statusDropdownText])

    const handleResetFilter = () => {
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText('Select Status')
        setSearchText('')
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    };

    // Handle Network Provider Modal
    const handleNetworkProviderClick = async (networkProviderIds) => {
        if (!networkProviderIds || networkProviderIds.length === 0) {
            showDangerToast('No network providers found');
            return;
        }
        
        setModalLoading(true);
        setShowNetworkProviderModal(true);
        
        try {
            // Call API to get network provider details by ID list
            const postJson = {
                idList: networkProviderIds
            };
            
            const res = await ApiCaller.post(postJson, urls.networkProviderDetails, userData?.access_token);
            const response = await res.response.json();
            
            if (response.status === 200 || response.status === '200') {
                // Transform the response data to match our table structure
                const transformedProviders = response.data.map(provider => ({
                    id: provider.key,
                    name: provider.value,
                    active: true, // Since these are active providers in the subscription
                    createdAt: null // Not provided in this API response
                }));
                setSelectedNetworkProviders(transformedProviders);
            } else {
                showDangerToast(response.message || 'Failed to fetch network provider details');
                setSelectedNetworkProviders([]);
            }
        } catch (error) {
            console.error('Error fetching network providers:', error);
            showDangerToast('Failed to fetch network provider details');
            setSelectedNetworkProviders([]);
        } finally {
            setModalLoading(false);
        }
    };

    // Handle Country Modal
    const handleCountryClick = async (countryIds) => {
        if (!countryIds || countryIds.length === 0) {
            showDangerToast('No country IDs found');
            return;
        }
        
        setModalLoading(true);
        setShowCountryModal(true);
        
        try {
            console.log('Country IDs received:', countryIds); // Debug log
            
            // Call API to get country details by ID list
            const postJson = {
                idList: countryIds
            };
            
            console.log('Making API call with payload:', postJson); // Debug log
            
            const res = await ApiCaller.post(postJson, urls.countryDetails, userData?.access_token);
            const response = await res.response.json();
            
            console.log('Full API Response:', response); // Debug log
            console.log('Response data:', response.data); // Debug log
            console.log('Response data type:', typeof response.data); // Debug log
            console.log('Response data length:', response.data?.length); // Debug log
            
            if (response.status === 200 || response.status === '200') {
                // Handle different possible response formats
                let countries = [];
                
                if (response.data && Array.isArray(response.data)) {
                    // Check if it's key-value format like network providers
                    if (response.data.length > 0 && response.data[0].hasOwnProperty('key') && response.data[0].hasOwnProperty('value')) {
                        console.log('Detected key-value format');
                        countries = response.data.map(item => ({
                            id: item.key,
                            countryName: item.value,
                            name: item.value
                        }));
                    } else {
                        console.log('Using response data as-is');
                        countries = response.data;
                    }
                } else {
                    console.log('Unexpected response format');
                    countries = [];
                }
                
                console.log('Processed countries:', countries); // Debug log
                setSelectedCountries(countries);
                
                if (countries.length > 0) {
                    showToast('Country details loaded successfully');
                } else {
                    showDangerToast('No country details found in response');
                }
            } else {
                console.log('API call failed with status:', response.status);
                showDangerToast(response.message || 'Failed to fetch country details');
                setSelectedCountries([]);
            }
        } catch (error) {
            console.error('Error fetching country details:', error);
            showDangerToast('Failed to fetch country details');
            setSelectedCountries([]);
        } finally {
            setModalLoading(false);
        }
    };

    // Handle Add/Edit Viewer Subscription
    const handleAddViewerSubscription = () => {
        setViewerSubscriptionFormData({
            id: '',
            name: '',
            amount: 0,
            duration: 0,
            category: 'DAILY',
            benefit: '',
            selectedCountries: [],
            selectedNetworkProviders: [],
            networkProviders: []
        });
        setShowAddViewerSubscription(true);
    };

    const handleEditViewerSubscription = (item) => {
        setViewerSubscriptionFormData({
            id: item.id,
            name: item.name,
            amount: item.amount,
            duration: item.duration,
            category: item.category,
            benefit: item.benefit || '',
            selectedCountries: item.country || [],
            selectedNetworkProviders: item.networkProviders || [],
            networkProviders: item.networkProviders || []
        });
        setShowAddViewerSubscription(true);
    };

    useEffect(() => {
        dispatch(updateTopHeader('Viewer Subscription Manager'))
    }, []);

    useEffect(() => {
        if (viewPermission) {
            getViewerSubscriptionList()
        }
    }, [callAPi])

    const getViewerSubscriptionList = async () => {
        let startDateObject
        let endDateObject

        if (startDate !== null) {
            startDateObject = new Date(startDate?.$d).toISOString().split('T')[0]
        }
        if (endDate !== null) {
            endDateObject = new Date(endDate?.$d).toISOString().split('T')[0]
        }

        try {
            dispatch(updateLoading(true))
            let postJson = {
                pageNumber: pagerecord?.pageNumber - 1,
                pageSize: pagerecord?.pageSize,
                searchText: searchText,
                shortingField: sort_type,
                asc: sort_order,
                startDate: startDateObject ? startDateObject : null,
                endDate: endDateObject ? endDateObject : null
            }
            let path = urls.viewerSubscriptionList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 10
                })
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    };

    return <>
        <NavBar />
        <div className='main-content'>
            <NavBarTop />
            <div className='header'>
                <div className='logo'>
                    <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                </div>
            </div>
            {
                viewPermission ? (
                    <>
                        <div className='container-fluid mt--7'>
                            <div className='row'>
                                <div className='col text-left'>
                                    <div className='card shadow'>
                                        <div className='card-header border-0'>
                                            <div className='row align-items-center text-left'>
                                                <div className='col'>
                                                    <div className="d-flex align-items-center">
                                                        <div className='icon icon-shape bg-gradient-primary text-white rounded-circle shadow mr-3' style={{
                                                            width: '60px',
                                                            height: '60px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <i className='fas fa-users fa-lg'></i>
                                                        </div>
                                                        <div>
                                                            <h2 className='mb-1 text-dark font-weight-bold'>Viewer Subscription Plans</h2>
                                                            <p className='mb-0 text-muted d-flex align-items-center'>
                                                                <i className="fas fa-info-circle mr-2 text-info"></i>
                                                                Manage subscription plans for viewers with detailed pricing and features
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-auto'>
                                                    {userData.admin ? (
                                                        <a
                                                            onClick={handleAddViewerSubscription}
                                                            className='btn btn-sm btn-primary text-white'
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <AddIcon />
                                                            Add New Plan
                                                        </a>
                                                    ) : editPermission ? (
                                                        <a
                                                            onClick={handleAddViewerSubscription}
                                                            className='btn btn-sm btn-primary text-white'
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <AddIcon />
                                                            Add New Plan
                                                        </a>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-header border-0'>
                                            <div className='row align-items-end text-left g-3' style={{ paddingBottom: '15px' }}>
                                                <div className='col-md-3'>
                                                    <div className="form-group mb-0">
                                                        <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                            <i className="fas fa-search mr-1"></i>Search Plans
                                                        </label>
                                                        <InputGroup>
                                                            <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
                                                                <i className="fas fa-search text-muted"></i>
                                                            </InputGroup.Text>
                                                            <Form.Control
                                                                placeholder='Search by name...'
                                                                value={searchText}
                                                                onChange={(e) => setSearchText(e.target.value)}
                                                                style={{ 
                                                                    fontSize: '14px',
                                                                    height: '38px',
                                                                    border: '1px solid #dee2e6'
                                                                }}
                                                            />
                                                        </InputGroup>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className="form-group mb-0">
                                                        <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                            <i className="fas fa-calendar-alt mr-1"></i>Start Date
                                                        </label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                value={startDate}
                                                                onChange={(newValue) => setStartDate(newValue)}
                                                                slotProps={{ 
                                                                    textField: { 
                                                                        size: 'small',
                                                                        fullWidth: true,
                                                                        variant: 'outlined',
                                                                        placeholder: 'Select start date'
                                                                    } 
                                                                }}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '38px',
                                                                        fontSize: '14px',
                                                                        backgroundColor: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '0.375rem',
                                                                        '&:hover': {
                                                                            borderColor: '#86b7fe'
                                                                        },
                                                                        '&.Mui-focused': {
                                                                            borderColor: '#86b7fe',
                                                                            boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.25)'
                                                                        }
                                                                    },
                                                                    '& .MuiInputLabel-root': {
                                                                        display: 'none'
                                                                    }
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className="form-group mb-0">
                                                        <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                            <i className="fas fa-calendar-alt mr-1"></i>End Date
                                                        </label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                value={endDate}
                                                                onChange={(newValue) => setEndDate(newValue)}
                                                                slotProps={{ 
                                                                    textField: { 
                                                                        size: 'small',
                                                                        fullWidth: true,
                                                                        variant: 'outlined',
                                                                        placeholder: 'Select end date'
                                                                    } 
                                                                }}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '38px',
                                                                        fontSize: '14px',
                                                                        backgroundColor: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '0.375rem',
                                                                        '&:hover': {
                                                                            borderColor: '#86b7fe'
                                                                        },
                                                                        '&.Mui-focused': {
                                                                            borderColor: '#86b7fe',
                                                                            boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.25)'
                                                                        }
                                                                    },
                                                                    '& .MuiInputLabel-root': {
                                                                        display: 'none'
                                                                    }
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className="form-group mb-0">
                                                        <label className="form-control-label text-sm font-weight-bold text-muted mb-2 d-block">
                                                            <i className="fas fa-filter mr-1"></i>Status Filter
                                                        </label>
                                                        <Dropdown className='w-100'>
                                                            <Dropdown.Toggle 
                                                                variant='outline-secondary' 
                                                                id='dropdown-basic' 
                                                                className='w-100 text-left'
                                                                style={{ 
                                                                    height: '38px', 
                                                                    fontSize: '14px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    border: '1px solid #dee2e6',
                                                                    backgroundColor: '#fff'
                                                                }}
                                                            >
                                                                {statusDropdownText}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='w-100'>
                                                                <Dropdown.Item onClick={() => setStatusDropdownText('Select Status')}>All</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => setStatusDropdownText('Active')}>Active</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => setStatusDropdownText('Inactive')}>Inactive</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <div className='col-md-1'>
                                                    <div className="d-grid">
                                                        <Button 
                                                            variant='primary' 
                                                            onClick={handleFilterClick}
                                                            style={{
                                                                height: '38px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <i className="fas fa-search mr-2"></i>
                                                            Filter
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className="d-grid">
                                                        <Button 
                                                            variant='outline-secondary' 
                                                            onClick={handleResetFilter}
                                                            style={{
                                                                height: '38px',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <i className="fas fa-undo mr-2"></i>
                                                            Reset Filter
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='table-responsive'>
                                            <table className='table align-items-center table-flush'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th scope='col'>#</th>
                                                        <th scope='col'>Name</th>
                                                        <th scope='col'>Amount</th>
                                                        <th scope='col'>Category</th>
                                                        <th scope='col'>Duration (seconds)</th>
                                                        <th scope='col'>Network Providers</th>
                                                        <th scope='col'>Countries</th>
                                                        <th scope='col'>Created At</th>
                                                        <th scope='col'>Status</th>
                                                        <th scope='col'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datalist.length === 0 ? (
                                                        <tr>
                                                            <td colSpan='10' className='text-center'>
                                                                <div className='text-center p-4'>
                                                                    <img
                                                                        src={NoDataImg}
                                                                        alt='No data found'
                                                                        style={{ width: '200px', height: 'auto' }}
                                                                    />
                                                                    <h5 className='mt-3'>No viewer subscriptions found</h5>
                                                                    <p className='text-muted'>There are no viewer subscription plans available at the moment.</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        datalist?.map((itemData, i) => {
                                                            const startIndex = (pagerecord?.pageNumber - 1) * pagerecord?.pageSize;
                                                            return (
                                                                <tr key={itemData?.id}>
                                                                    <td>{startIndex + i + 1}</td>
                                                                    <td>{itemData?.name}</td>
                                                                    <td>GH₵ {itemData?.amount ? itemData?.amount.toFixed(2) : "0.00"}</td>
                                                                    <td>
                                                                        <span className={`badge badge-pill ${
                                                                            itemData?.category === 'DAILY' ? 'badge-success' :
                                                                            itemData?.category === 'WEEKLY' ? 'badge-info' :
                                                                            itemData?.category === 'MONTHLY' ? 'badge-warning' :
                                                                            'badge-secondary'
                                                                        }`}>
                                                                            {itemData?.category}
                                                                        </span>
                                                                    </td>
                                                                    <td>{itemData?.duration ? itemData?.duration.toLocaleString() : "-"}</td>
                                                                    <td>
                                                                        {itemData?.networkProviders && itemData.networkProviders.length > 0 ? (
                                                                            <span 
                                                                                className="badge badge-primary" 
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleNetworkProviderClick(itemData.networkProviders)}
                                                                            >
                                                                                {itemData.networkProviders.length} Provider{itemData.networkProviders.length !== 1 ? 's' : ''}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">0 Providers</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {itemData?.countryDetails && itemData.countryDetails.length > 0 ? (
                                                                            <span 
                                                                                className="badge badge-info" 
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleCountryClick(itemData.country || [])}
                                                                            >
                                                                                {itemData.countryDetails.length} Countr{itemData.countryDetails.length !== 1 ? 'ies' : 'y'}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-secondary">0 Countries</span>
                                                                        )}
                                                                    </td>
                                                                    <td>{formatDate(itemData?.createdAt)}</td>
                                                                    <td>
                                                                        {userData.admin ? (
                                                                            <Switch
                                                                                {...label}
                                                                                checked={itemData?.active}
                                                                                onChange={(e) =>
                                                                                    handleStatusChange(e, itemData?.id)
                                                                                }
                                                                                size='small'
                                                                            />
                                                                        ) : activePermission ? (
                                                                            <Switch
                                                                                {...label}
                                                                                checked={itemData?.active}
                                                                                onChange={(e) =>
                                                                                    handleStatusChange(e, itemData?.id)
                                                                                }
                                                                                size='small'
                                                                            />
                                                                        ) : (
                                                                            <span className={`badge badge-pill ${itemData?.active ? 'badge-success' : 'badge-danger'}`}>
                                                                                {itemData?.active ? 'Active' : 'Inactive'}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {userData.admin || editPermission ? (
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => handleEditViewerSubscription(itemData)}
                                                                                title="Edit Plan"
                                                                            >
                                                                                <i className="fas fa-edit"></i>
                                                                            </button>
                                                                        ) : (
                                                                            <span className="text-muted">No actions</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className='card-footer py-4'>
                                            {pagerecord?.totalItems > 0 && (
                                                <Box display="flex" justifyContent="center">
                                                    <Pagination
                                                        count={pagerecord?.totalPages}
                                                        page={page}
                                                        onChange={handleChange}
                                                        color="primary"
                                                        showFirstButton
                                                        showLastButton
                                                    />
                                                </Box>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Network Provider Details Modal */}
                        <Modal 
                            show={showNetworkProviderModal} 
                            onHide={() => setShowNetworkProviderModal(false)}
                            size="lg"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Network Providers</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {modalLoading ? (
                                    <div className="text-center p-4">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading network providers...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Provider Name</th>
                                                    <th>Provider ID</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedNetworkProviders.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="4" className="text-center">
                                                            <p className="text-muted">No network providers found</p>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    selectedNetworkProviders.map((provider, index) => (
                                                        <tr key={provider.id || index}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <strong>{provider.name || provider.value || 'N/A'}</strong>
                                                            </td>
                                                            <td>
                                                                <small className="text-muted font-monospace">
                                                                    {provider.id || provider.key || 'N/A'}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <span className="badge badge-success">
                                                                    Active
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowNetworkProviderModal(false)}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Country Details Modal */}
                        <Modal 
                            show={showCountryModal} 
                            onHide={() => setShowCountryModal(false)}
                            size="lg"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Country Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {modalLoading ? (
                                    <div className="text-center p-4">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading country details...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Country Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedCountries.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="2" className="text-center">
                                                            <p className="text-muted">No country details found</p>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    selectedCountries.map((country, index) => (
                                                        <tr key={country.id || country.countryId || country.key || index}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <strong>
                                                                    {country.countryName || 
                                                                     country.name || 
                                                                     country.value || 
                                                                     country.country || 
                                                                     'N/A'}
                                                                </strong>
                                                                {country.id && (
                                                                    <small className="d-block text-muted font-monospace">
                                                                        ID: {country.id || country.key}
                                                                    </small>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowCountryModal(false)}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Add/Edit Viewer Subscription Modal */}
                        <AddViewerSubscription
                            show={showAddViewerSubscription}
                            viewerSubscriptionFormData={viewerSubscriptionFormData}
                            setViewerSubscriptionFormData={setViewerSubscriptionFormData}
                            onSubmit={() => {
                                setShowAddViewerSubscription(false);
                                setCallAPi(uuidv4()); // Refresh the list
                            }}
                            onHide={() => setShowAddViewerSubscription(false)}
                        />
                    </>
                ) : (<InsufficientPermission />)
            }
        </div>
    </>
}